<template>
	<CardGrafico
		v-if="!reportMode"
		:title="$t('proporcaoDeFustes')"
		:subtitle="subtitle"
	>
		<template #botoes>
			<div v-show="!reportMode">
				<ButtonDropdown
					v-model="dropdownDownload"
					style="margin-top: 0.5rem"
					color="trv-neutral"
					:label="$t('download')"
					semantic-class="mini"
					:options="[
						{ label: 'PNG', value: 'image/png' },
						{ label: 'JPEG', value: 'image/jpeg' },
						{ label: 'PDF', value: 'application/pdf' },
						{ label: 'SVG', value: 'image/svg+xml' },
						// { label: '.csv', value: 'text/csv' },
					]"
					outlined
				/>
			</div>
		</template>
		<template #grafico>
			<Loading v-if="data.length === 0" />
			<div
				v-else
				class="container__graficofazenda"
			>
				<Chart
					ref="ref__chart"
					:options="chartOptions"
				/>
			</div>
		</template>
	</CardGrafico>
	<Chart
		v-else
		ref="ref__chart"
		style="width: 55vw"
		:options="chartOptions"
	/>
</template>

<script>
import { corDeterministicaDeCategoria } from '../../../../utils/coresDeCategoria'
import { Chart } from 'highcharts-vue'
import ButtonDropdown from '../../../../components/ButtonDropdown/ButtonDropdown'
import Loading from '../../../../components/Loading/Loading'
import i18n from '../../../../VueI18n'
import CardGrafico from '../CardGrafico'

export default {
	components: { ButtonDropdown, CardGrafico, Chart, Loading },

	props: {
		/**
		 * Diz para o componente que ele está sendo utilizado em relatórios, assim
		 * é possível ocultar elementos de tela que demandam ação do usuário
		 */
		reportMode: {
			type: Boolean,
			default: false,
		},
		/**
		 * Dados que devem ir para o grafico
		 */
		data: { type: [Array, Object], required: true },

		/**
		 * Data do ultimo processamento como subtitulo
		 */
		subtitle: { type: String, required: true },
	},

	data() {
		return {
			categoriasArvore: [],
			dropdownDownload: '',
			chartOptions: {
				/**
				 * Creditos no canto inferior direito do grafico
				 */
				credits: {
					enabled: false,
				},
				exporting: {
					enabled: false,
				},
				chart: {
					type: 'pie',
				},
				title: {
					text: this.reportMode ? this.subtitle : '',
				},
				tooltip: {
					formatter: function () {
						let tooltipHtml = `
            <div class="container__pie__tooltip__cabecalho">
            <span>${i18n.t('plantation')}</span>
            <span>${i18n.t('total')}</span>
            </div>
              `
						this.point.plantiosComMaisArvores?.forEach((plantio) => {
							tooltipHtml += `
            <div class="container__pie__tooltip__info bigger" >
            <span>${plantio.codigoDoPlantio}</span>
            <span>${plantio.quantidade}</span>
            </div>

          `
						})

						// const plantiosJaAdicionados = this.point.plantiosComMaisArvores
						//   ? this.point.plantiosComMaisArvores.map((m) => m.codigoDoPlantio)
						//   : [];

						// this.point.plantiosComMenosArvores?.forEach((plantio) => {
						//   if (!plantiosJaAdicionados.includes(plantio.codigoDoPlantio)) {
						//     tooltipHtml += `
						//       <div class="container__pie__tooltip__info minors">
						//         <span>${plantio.codigoDoPlantio}</span>
						//         <span>${plantio.quantidade}</span>
						//       </div>
						//     `;
						//   }
						// });
						return `
            <div class="container__pie__tooltip" style="overflow:auto; pointer-events: auto; max-height:200px;">
            <span>${this.y}</span>
            <span>${this.key}</span>
            ${tooltipHtml}
            </div>
            `
					},
					positioner: function (labelWidth, labelHeight) {
						return {
							x: this.chart.chartWidth / 2 - labelWidth / 2,
							y: this.chart.chartHeight / 2 - labelHeight / 2 - 10,
						}
					},
					shadow: false,
					borderWidth: 0,
					backgroundColor: 'rgba(255,255,255,0)',
					useHTML: true,
					hideDelay: 5000,
				},

				accessibility: {
					point: {
						valueSuffix: '%',
					},
				},
				plotOptions: {
					pie: {
						dataLabels: {
							formatter: function () {
								return `
                  <div class="container__pie__datalabel">
                    <span>${this.key}</span>
                    <span>${this.percentage.toFixed(2)}%</span>
                  </div>
                `
							},
							useHTML: true,
						},
					},
				},
				series: [
					{
						size: '80%',
						innerSize: '75%',
						data: [],
					},
				],
				responsive: {
					rules: [
						{
							condition: {
								maxWidth: 500,
							},
							chartOptions: {
								series: [
									{
										size: '50%',
										innerSize: '90%',
									},
								],
							},
						},
					],
				},
			},
		}
	},

	watch: {
		/**
		 * Atualiza o grafico sempre que a propriedade data e alterada
		 */
		data() {
			this.setHighchartsOptions()

			return {
				/**
				 * Opção selecionada para o download
				 */
				dropdownDownload: '',
			}
		},
		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},

	methods: {
		/**
		 * Seta os dados do grafico
		 */
		setHighchartsOptions() {
			const data = this.data.map((individualData) => {
				return {
					name: individualData.categoriaDeArvore,
					y: individualData.quantidadeTotal,
					color:
						individualData.cor || corDeterministicaDeCategoria(individualData.categoriaDeArvore),
					plantiosComMaisArvores: individualData.plantios,
					// plantiosComMenosArvores:
					//   individualData.plantiosComMenosArvoresDestaCategoria,
				}
			})
			this.chartOptions.series[0].data = data
		},
	},
}
</script>

<style scoped>
@import url('../../../../css/PieHighcharts.css');
.container__graficofazenda {
	display: grid;
}
</style>
